export default {
  /**
   * 求平均值
   *
   * @param array
   * @returns {number}
   */
  average (array) {
    var sum = 0
    array.forEach((obj, index) => {
      sum += Number(array[index])
    })
    return sum / array.length
  },
  /**
   * 获得四舍五入后的数字字符串
   *
   * @param n
   * @param decimals 保留的小数位数
   * @returns {string}
   */
  toFixed (n, decimals = 0) {
    return _.round(Number(n), decimals)// Number(n).toFixed(decimals)
  },
  /**
   * 返回千位数分隔的数字
   * @param n
   * @returns {string}
   */
  seperateThousands (n) {
    return Number(n).toLocaleString('en-US')
  },
  /**
   * 返回千位数分隔的四舍五入后保留decimals小数的数字
   * @param n
   * @param decimals 保留的小数位数
   * @returns {string}
   */
  seperateThousandsToFixed (n, decimals = 0) {
    return _.round(Number(n), decimals).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')// Number(n).toFixed(decimals).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
  }
}



// WEBPACK FOOTER //
// ./core/filters/math.js